import { render, staticRenderFns } from "./LogoutConfirm.vue?vue&type=template&id=ef10f2a0&scoped=true&"
import script from "./LogoutConfirm.vue?vue&type=script&lang=js&"
export * from "./LogoutConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LogoutConfirm.vue?vue&type=style&index=0&id=ef10f2a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef10f2a0",
  null
  
)

export default component.exports